/**
 * Preset Manager for saving and loading guitar neck patterns
 */
import { getUserMap, saveUserItem, deleteUserItem } from '../data/userStore';

/**
 * Save a pattern preset to the user mirror (write-through IndexedDB)
 * @param {string} name - Name of the preset
 * @param {Object} preset - Preset data to save
 * @returns {boolean} - Success status
 */
export const savePatternPreset = (name, preset) => {
  try {
    saveUserItem('preset', name, {
      ...preset,
      timestamp: Date.now()
    });
    return true;
  } catch (error) {
    console.error('Error saving pattern preset:', error);
    return false;
  }
};

/**
 * Get all pattern presets from the user mirror
 * @returns {Object} - Object containing all presets
 */
export const getPatternPresets = () => {
  try {
    return getUserMap('preset');
  } catch (error) {
    console.error('Error getting pattern presets:', error);
    return {};
  }
};

/**
 * Delete a pattern preset from the user mirror
 * @param {string} name - Name of the preset to delete
 * @returns {boolean} - Success status
 */
export const deletePatternPreset = (name) => {
  try {
    const existingPresets = getPatternPresets();

    if (existingPresets[name]) {
      deleteUserItem('preset', name);
      return true;
    }

    return false;
  } catch (error) {
    console.error('Error deleting pattern preset:', error);
    return false;
  }
};
